import moment from 'moment-timezone';
import { useAuthStore } from '@stores/auth';

const MEXICO_TIMEZONE = 'America/Mexico_City';

export const syncServerTime = (serverTimestamp) => {
  try {
    const clientTime = Date.now();
    const serverTime = moment(serverTimestamp).valueOf();
    const serverTimeOffset = serverTime - clientTime;

    useAuthStore.getState().setServerTimeOffset(serverTimeOffset);

    return serverTimeOffset;
  } catch (error) {
    console.error('Failed to sync server time:', error);
    return 0;
  }
};

export const getMexicoTimestamp = () => {
  const serverTimeOffset = useAuthStore.getState().getServerTimeOffset();
  const adjustedTime = moment().add(serverTimeOffset, 'milliseconds').tz(MEXICO_TIMEZONE);
  console.log("Adjusted Time:", adjustedTime.toString(),
    "Mexico Time:", adjustedTime.tz(MEXICO_TIMEZONE).toString(),
    "UTC Time:", adjustedTime.clone()?.utc()?.toString(),
    "Offset (ms):", serverTimeOffset,
    "Format:", adjustedTime.format('YYYY-MM-DDTHH:mm:ss') + 'Z');
  return adjustedTime.format('YYYY-MM-DDTHH:mm:ss') + 'Z';
};

export const getMexicoTime = () => {
  const serverTimeOffset = useAuthStore.getState().getServerTimeOffset();
  const adjustedTime = moment().add(serverTimeOffset, 'milliseconds');
  return adjustedTime.tz(MEXICO_TIMEZONE);
};

export const toMexicoTime = (timestamp) => {
  return moment(timestamp).tz(MEXICO_TIMEZONE);
};
